import React from "react";
import { Col, Form, Row } from "react-bootstrap";
import { CCAssessmentType } from "../../Physician/Models/CCEnrollment";
import { getDateWithOffset } from "../../Shared/Utility/GetDateWithOffset";
import CcAssessmentPathwayEnrollment from "../Models/CcAssessmentPathwayEnrollment";

interface IProps{
    pathwayEnrollment: CcAssessmentPathwayEnrollment;
}
export default function ExamRequirementPreview(props: IProps){
    const getAbccInEligibleCerts = () => {
        return props.pathwayEnrollment.ccEnrollmentCertificates.filter(_ => _.isEnrolled &&  (_.ccAssessmentType == CCAssessmentType.Other));
    }

    const getExamCertifications = () => {
        return props.pathwayEnrollment.ccEnrollmentCertificates.filter(_ => _.isEnrolled &&  (_.ccAssessmentType == CCAssessmentType.Exam || _.ccAssessmentType == CCAssessmentType.Other));
    }

    const getExamAssessmentTitle = () => {
        return getAbccInEligibleCerts().length > 0 ? "Exam/Assessment" : "Exam"; 
    }

    const formatExamDue = (value: string) => {
        var date = getDateWithOffset(value);
        if (date == null) return ""
        return date.getFullYear();
    }

    if (getExamCertifications().length == 0) return (<React.Fragment></React.Fragment>);
    return (
        <React.Fragment>
            <div className="pp-assessment-review-section">
            <p className="font-weight-bold">{getExamAssessmentTitle()} Requirements</p>
            <Form.Group>
                <Col>
                <Row className="pp-assessment-review-item">
                    <Col><strong>Certification</strong></Col>
                    <Col><strong>{getExamAssessmentTitle()} Due</strong></Col>
                </Row>
                {getExamCertifications().map(_ => 
                <Row className="pp-assessment-review-item">
                    <Col className="pp-assessment-review-item-col">{_.certificationName} {(!_.isAbccEligible) && <span>**</span> }</Col>
                    <Col className="pp-assessment-review-item-col">{formatExamDue(_.expirationDate)}</Col>
                </Row>
                )}
                </Col>
            </Form.Group>
            <Form.Group>
                <p className="pp-font-size-smallest">** For certifications that are not administered by the ABPN, the date below reflects the year by which an application must be submitted to the ABPN and an examination must be passed or a longitudinal assessment begun.</p>
            </Form.Group>
            
            </div>
        </React.Fragment>
    );
}

